import React, { useState } from 'react';
import styled from 'styled-components';

import Select from '../../../src/components/StyledComponents/Select';
import { H3 } from '../../../src/components/StyledComponents/TextStyles';

const NoteWrapper = styled.article`
	background-color: var(--color-gray-100);
	--border-light: rgba(239, 241, 245, 0.2);
	--border-dark: rgba(239, 241, 245, 0.2);

	.note-cover {
		min-width: 100px;
		/* max-width: inherit; */
	}

	.note-title {
		color: var(--color-primary);
	}

	.note-review.excerpt:hover {
		cursor: pointer;
		background-color: var(--color-gray-200);
		transition: background-color 0.2s ease-in-out;
	}

	.note-review.excerpt p {
		display: none;
	}

	.note-review.excerpt > p:first-child {
		overflow: hidden;
		margin-bottom: 0;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
	}

	.note-review.full-note p {
		display: block;
	}
`;

const NoteControlsWrapper = styled.section`
	span.note-type-chip {
		line-height: 22px;
		font-family: var(--font-heading);
	}

	span.note-type-chip.active {
		border-width: 2px;
		font-weight: bold;
		color: var(--color-dark-background);
		border-color: var(--color-tertiary);
		background-color: var(--color-tertiary);
	}
`;

const noteSortOptions = [
	{
		value: 1,
		label: 'Title A-Z',
	},
	{
		value: 2,
		label: 'Title Z-A',
	},
];

const getSortKey = (value) => {
	if (value == 1) {
		return 'title-asc';
	} else if (value == 2) {
		return 'title-dsc';
	}

	return 'title-dsc';
};

const data = [
	{
		id: '_note85XB4',
		title: 'Da 5 Bloods',
		poster:
			'https://upload.wikimedia.org/wikipedia/en/thumb/f/f0/Da_5_Bloods_poster.jpeg/220px-Da_5_Bloods_poster.jpeg',
		description:
			"During the Vietnam War, a squad of Black US Army soldiers of the 1st Infantry Division, Paul, Otis, Eddie, Melvin and their squad leader Norman, who dub themselves the \"Bloods,\" secure the site of a CIA airplane crash and recover its cargo, a locker of gold bars intended as payment for the Lahu people for their help in fighting the Viet Cong. The Bloods decide to take the gold for themselves and bury it so they can retrieve it later. However, in the ensuing Vietnamese counter-attack, Norman is killed and the Bloods cannot locate the buried gold after a napalm strike obliterates all of the identifying landmarks. In the present day, Paul, Otis, Eddie and Melvin meet up in Ho Chi Minh City. A recent landslide had uncovered the tail of the crashed plane, and with this new information they plan to find the gold and Norman's body. Otis reunites with his old Vietnamese girlfriend Tiên, who reveals that he is the father of her grown child. Tiên introduces the Bloods to Desroche, a French businessman who agrees to help the Bloods smuggle the gold out of Vietnam once they retrieve it. Soon thereafter, Paul's son David joins the mission. Vinh, a tour guide hired by the Bloods, leads the group out into the countryside, where a confrontation with a local merchant forces Paul to admit that he has post-traumatic stress disorder. At a hotel bar, David meets Hedy, the founder of LAMB, an organization dedicated to clearing landmines. The next day, Vinh drops off the group and tells them he will pick them up in a few days. During their first night, Paul confiscates a pistol Otis had been secretly given by Tiên and becomes suspicious of his motives. Eventually, the Bloods find the gold bars scattered across the side of a hill. They also find Norman's remains and pray over them. Eddie reveals that his excessive spending has rendered him broke, but reminds the Bloods of Norman's original plan to give the gold to their black brethren in the United States.",
	},
	{
		id: '_noteY7F32',
		title: 'The Way Back',
		poster:
			'https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/The_Way_Back_poster.jpeg/220px-The_Way_Back_poster.jpeg',
		description:
			"Jack Cunningham is an alcoholic construction worker who is separated from his wife, Angela. While at Thanksgiving dinner with his mother, his sister Beth, and her family, Beth reveals that friends, including Angela, have expressed concern about his drinking and isolation from friends and family. The next day, Jack receives a call from Father Devine at his Catholic high school Bishop Hayes, where he was a star basketball player and led the team to multiple championships. Father Devine asks him to step in as the school's basketball coach, as the current coach has suffered a heart attack. Jack is initially reluctant, but accepts the job. Jack is introduced to assistant coach and algebra teacher Dan, as well as members of the team. Bishop Hayes has only won one game, and has not gone to the playoffs since Jack was a student. As a result, student interest in basketball has dropped greatly, leaving the team with just six varsity players. Among these players are Brandon, the team's introverted point guard and most talented player, and Marcus, the team's center, who aggravates his teammates and Jack with his attitude. Angela meets with Jack and reveals that she is seeing someone new. Jack continues drinking heavily; his friend Doc takes him home from the bar every night, making sure he arrives safely. The team faces Memorial, a larger school with a much more talented team, in one of Jack's first games as coach. Trailing significantly and frustrated at a perceived lack of effort, Jack benches Marcus and demands the team play with more toughness. Nevertheless, Bishop Hayes loses badly. Dan begins to notice signs of Jack's alcoholism, including an allusion to his drinking habits by Memorial's coach and finding beer cans in Jack's office.",
	},
	{
		id: '_noteUK3IR',
		title: 'The Trial of the Chicago 7',
		poster:
			'https://upload.wikimedia.org/wikipedia/en/thumb/c/c2/TrialChicago7poster.jpeg/220px-TrialChicago7poster.jpeg',
		description:
			"In August 1968, Abbie Hoffman, Jerry Rubin, Tom Hayden, Rennie Davis, David Dellinger, Lee Weiner, John Froines, and Bobby Seale begin to prepare to protest at the Democratic National Convention in Chicago. Five months later, all eight of them are arrested and are charged with trying to incite a riot. John N. Mitchell, the Attorney General appoints Tom Foran and Richard Schultz as the prosecutors, while all the defendants except Seale are represented by William Kunstler and Leonard Weinglass. Judge Julius Hoffman shows significant prejudice for the prosecution. Seale's attorney is not present and he receives help from Fred Hampton. Abbie Hoffman openly antagonizes the court. Judge Hoffman begins removing jurors who are suspected of sympathizing with the defendants because of reported threats from the Black Panther Party and gives the defendants and their attorneys multiple contempt of court charges. Numerous undercover cops testify. One night, Hayden noticed two cops tailing Davis and attempted to let the air out of their tire, but was caught and later arrested. Abbie led a protest to the police station where Hayden was being kept, but turned around upon seeing the police blockade outside. When attempting to return to the park, police had taken control of the hill. A riot ensued, and the protestors claimed the hill again. Kunstler makes a point that none of the defendants instigated the riot. It is reported that Hampton is killed during a police raid. In retaliation to Seale continuing to speak up for his constitutional rights, Judge Hoffman has him taken to another room, beaten, and returned gagged and chained. Judge Hoffman takes Schultz's suggestion of declaring Seale's case a mistrial.",
	},
	{
		id: '_note1O0QT',
		title: "I'm Thinking of Ending Things",
		poster:
			'https://upload.wikimedia.org/wikipedia/en/2/2f/I%27m_Thinking_Of_Ending_Things_poster.jpeg',
		description:
			"A young woman contemplates ending her six-week relationship with her boyfriend, Jake, while taking a trip to meet Jake's parents on their farm. During the drive, Jake attempts to recite a poem he read when he was younger, Ode: Intimations of Immortality, and pressures the woman into performing one of her works in the car to pass time. After she recites a morbid poem about coming home, they arrive at the farmhouse. Jake takes the young woman to the barn, where he recounts a story about a maggot-infested pig. Throughout the drive, as well as later scenes in the film, the main narrative is intercut with footage of a janitor working at a high school, including scenes where he sees a musical production rehearsal, and a dance in the school's hallway. Inside the home, the young woman notices scratches on the basement door. At dinner with Jake's parents, the woman, who is described as having different occupations, shares one of her verses[a] and tells the story of how she and Jake met at a trivia night, told with narrative inconsistencies. Later, she notices a picture of Jake as a child, but becomes confused after recognizing that child as herself.",
	},
	{
		id: '_noteB31XA',
		title: 'Enola Holmes',
		poster:
			'https://upload.wikimedia.org/wikipedia/en/e/e6/Enola_Holmes_poster.jpeg',
		description:
			'Enola Holmes is the youngest sibling in the famous Holmes family. She is extremely intelligent, observant, and insightful, and defies the social norms for women of the time. Her mother, Eudoria, has taught her everything from chess to jujitsu and encouraged her to be a strong-willed and independent thinking young woman. On the day of her sixteenth birthday, Enola awakens to find that her mother has disappeared, leaving behind only some birthday gifts. She rushes to the train station to meet her brothers, Mycroft and Sherlock, who fail to recognize her at first, not having seen her in many years. Sherlock finds her to be an intelligent girl, whereas Mycroft finds her troublesome. As her legal guardian, Mycroft intends to send her away to a finishing school run by the stern Miss Harrison. The flowers left by her mother reveal secret messages and lead to hidden money, which Enola uses to escape disguised as a boy. On the train, she finds the young Viscount Tewkesbury hidden in a travel bag. She thinks he is a nincompoop but warns him that a man in a brown bowler hat (named Linthorn) is on the train searching for him. They jump off the train to escape. Neither having any food, Tewkesbury forages for edible plants. They travel to London, where they part ways.',
	},
];

const NoteControls = ({ sort, filterByType, currentNoteType }) => {
	return (
		<NoteControlsWrapper className="flex flex-row justify-end items-end py-1 sm:mb-2">
			<div className="note-controls-sorter mb-4 sm:mb-0">
				<Select onChange={sort} options={noteSortOptions} />
			</div>
		</NoteControlsWrapper>
	);
};

const Note = ({ note, isLastNote }) => {
	const [showFullDescription, enableFullDescription] = useState(false);

	const { title, poster, description } = note;

	const wrapperClass = isLastNote
		? 'clear-both relative md:flex px-8 py-4 md:py-8'
		: 'clear-both relative md:flex px-8 py-4 md:py-8 border-b-1 border-gray-100';

	const noteReviewClass = showFullDescription ? 'full-note' : 'excerpt';

	const toggleNoteDescription = () => {
		if (!showFullDescription) {
			enableFullDescription(true);
		}
	};

	return (
		<NoteWrapper className={wrapperClass}>
			<div className="note-cover relative float-left md:float-none pr-4 pb-2">
				<img alt={title} src={poster} className="rounded shadow-xl" />
			</div>
			<section className="note-review-content relative z-10 sm:px-2">
				<header>
					<H3 customClass="note-title heading pb-4 default-transition">
						{title}
					</H3>
				</header>
				<div
					onClick={toggleNoteDescription}
					className={`note-review ${noteReviewClass} rounded text-xs md:text-sm lg:text-base lg:py-1`}
				>
					<p>{description}</p>
				</div>
			</section>
		</NoteWrapper>
	);
};

const NotesList = ({ setKey, showControls }) => {
	const [notesList, updateNotesList] = useState(data);

	const sort = (e) => {
		e.persist();

		const [sortKey, sortDir = 'dsc'] = getSortKey(e.target.value).split('-');

		const sortedNotes = [...notesList];

		sortedNotes.sort((a, b) => {
			if (sortDir === 'asc') {
				return a.title.localeCompare(b.title);
			}

			return b.title.localeCompare(a.title);
		});

		updateNotesList(sortedNotes);
	};

	const list = notesList.map((note, index) => {
		const key = setKey ? note.id : index;
		const isLastNote = index === notesList.length - 1;

		return <Note key={key} note={note} isLastNote={isLastNote} />;
	});

	return (
		<div className="mb-8">
			{showControls ? <NoteControls sort={sort} /> : null}
			{list}
		</div>
	);
};

export default NotesList;
